import { render, staticRenderFns } from "./OperationLog.vue?vue&type=template&id=2b481287"
import script from "./OperationLog.vue?vue&type=script&lang=js"
export * from "./OperationLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports